import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "jspdf/dist/polyfills.es.js";
import moment from "moment";
import * as React from "react";
import { Component, Fragment } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import SignaturePad from "react-signature-canvas";
import ReactMarkdown from "react-markdown";

import Button from "../../../../components/UI/Button/Button";
import Input from "../../../../components/UI/Input/Input";
import * as actions from "../../../../store/actions/index.js";
import { setDateFormat } from "../../../../utils/index.js";
import classes from "./AddSignature.module.css";

interface IParentProps {
  closeAddSignature: (disputeAuthorizationFormSigned: boolean) => void;
}
interface IStateFromProps {
  newUploadData: {
    beneficiarySelected: string;
    dateOfService: string;
    procedureLabel: string;
    providerName: string;
    totalCharge: string;
    isMinor: boolean;
    primaryAccountHolder: boolean;
    patientId: number;
    dateOfBirth: string;
  };
  t: any;
  i: any;
}
interface IDispatchFromProps {
  //onDisputeAuthorizationFile: (file: File) => void;
  onDisputeAuthorizationFile: (file: any) => void;
  onConstructUpdatedAddress: (name: string, value: string) => void;
}
type Props = IParentProps & IStateFromProps & IDispatchFromProps;
class AddSignature extends Component<Props> {
  state = {
    trimmedDataURL: "",
    imageData: "",
    signatureAdded: false,
    guardianTrimmedDataURL: "",
    guardianImagedata: "",
    guardianSignatureAdded: false,
    currentDate: moment().format("MM/DD/YYYY"),
    address: "",
    city: "",
    state: "",
    zipCode: "",
    errorAddress: "",
    errorCity: "",
    errorZipCode: "",
    errorState: "",

    disputeFormWidth: 320,
    signBox: 100,
  };
  sigPadPatient;
  sigPadGuardian;
  clearSignature = () => {
    if (this.sigPadPatient) this.sigPadPatient.clear();
    if (this.sigPadGuardian) this.sigPadGuardian.clear();
    this.setState({ signatureAdded: false });
    this.setState({ guardianSignatureAdded: false });
  };
  // trim = () => {
  //   this.setState({
  //     trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
  //   });
  // };
  validateAuthForm = () => {
    // let addressSpan = document.getElementById("address")?.innerText;
    // let citySpan = document.getElementById("city")?.innerText;
    // let stateSpan = document.getElementById("state")?.innerText;
    // let zipCodeSpan = document.getElementById("zipCode")?.innerText;
    const { t } = this.props;
    let formIsValid = true;
    let address = this.state.address;
    let state = this.state.state;
    let city = this.state.city;
    let zipCode = this.state.zipCode;
    if (address === "") {
      formIsValid = false;
      this.setState({
        errorAddress: t("errorMsg.address"),
        // errorAddress:t('errorMsg.errorProcedureLabel'),
      });
    }
    if (city === "") {
      formIsValid = false;
      this.setState({
        errorCity: t("errorMsg.city"),
      });
    } else if (city !== "") {
      let regex = /^[A-Za-z ]+$/;
      if (!regex.test(city)) {
        formIsValid = false;
        this.setState({
          errorCity: t("errorMsg.validCity"),
        });
      }
    }
    if (state === "") {
      formIsValid = false;
      this.setState({
        errorState: t("errorMsg.state"),
      });
    } else if (state !== "") {
      let regex = /^[A-Za-z ]+$/;
      if (!regex.test(state)) {
        formIsValid = false;
        this.setState({
          errorState: t("errorMsg.validState"),
        });
      }
    }
    if (zipCode === "") {
      formIsValid = false;
      this.setState({
        errorZipCode: t("errorMsg.postalCode"),
      });
    }
    return formIsValid;
  };
  isValidPostalCode = () => {
    let isValid = true;
    const { t } = this.props;

    let regex = /^[0-9]{5}$/;
    if (!regex.test(this.state.zipCode)) {
      this.setState({
        errorZipCode: t("errorMsg.validPostalCode"),
      });
      isValid = false;
    }

    return isValid;
  };
  captureFormInImage = (download: boolean) => {
    if (this.validateAuthForm() && this.isValidPostalCode()) {
      if ((this.sigPadPatient && !this.sigPadPatient.isEmpty()) || (this.sigPadGuardian && !this.sigPadGuardian.isEmpty())) {
        // const HTML_Width =
        //   document.getElementById("mainContainer")?.offsetWidth! * 3;
        // const HTML_Height =
        //   document.getElementById("mainContainer")?.offsetHeight! * 3 || 10;
        // const top_left_margin = 15;
        // const bottom_margin = 50;
        // const top_margin = 20;
        // const PDF_Width = HTML_Width! + top_left_margin * 2;
        // const PDF_Height = PDF_Width! * 1.5 + top_left_margin * 2;
        // const canvas_image_width = HTML_Width;
        // const canvas_image_height =
        // HTML_Height + top_margin * 2 + bottom_margin;
        // const totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
        window.scrollTo(0, -10);
        html2canvas(document.getElementById("mainContainer")!, {
          // scrollX: -8,
          scrollY: -window.scrollY,
          scale: 2,
        }).then((canvas) => {
          canvas.getContext("2d");
          window.scrollTo(0, 0);
          console.log(canvas.height + "  " + canvas.width);
          const imgData = canvas.toDataURL("image/jpeg", 1.0);
          this.setState({ trimmedDataURL: imgData });

          if (download) {
            this.setState({
              disputeFormWidth: 800,
              signBox: 50,
            });
            // var a = document.createElement("a"); //Create <a>
            // a.href = imgData; //Image Base64 Goes here
            // a.download = "DisputeAuthorizationForm.png"; //File name Here
            // a.click(); //Downloaded file

            // canvasToBlob(canvas).then(function (blob) {
            //   saveAs(blob, "DisputeAuthorizationForm.png");
            // }).catch(function (err) {
            //   console.log("error: ", err)
            // });

            // var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
            // pdf.addImage(
            //   imgData,
            //   "JPG",
            //   top_left_margin!,
            //   top_left_margin!,
            //   canvas_image_width!,
            //   canvas_image_height!
            // );

            // for (var i = 1; i <= totalPDFPages; i++) {
            //   pdf.addPage("p");
            //   pdf.addImage(
            //     imgData,
            //     "JPG",
            //     top_left_margin!,
            //     -(PDF_Height * i) + top_left_margin * 4,
            //     canvas_image_width!,
            //     canvas_image_height
            //   );
            // }

            html2canvas(document.getElementById("mainContainer")!, {
              // scrollX: -8,
              scrollY: -window.scrollY,
              scale: 2,
            }).then((canvas: HTMLCanvasElement) => {
              canvas.getContext("2d");
              window.scrollTo(0, 0);
              console.log(canvas.height + "  " + canvas.width);
              const imgData1 = canvas.toDataURL("image/jpeg", 1.0);

              var pdf = new jsPDF("p", "mm");
              pdf.addImage(imgData1, "JPG", 0, 0, 210, 297);

              pdf.save("DisputeAuthorizationForm.pdf");
            });

            // var pdf = new jsPDF("p", "mm");
            // pdf.addImage(imgData, "JPG", 0, 0, 210, 297);

            // pdf.save("DisputeAuthorizationForm.pdf");
          }
          this.urltoFile(imgData, "disputeAuthorizationForm", "image/png");
          // this.props.onDisputeAuthorizationFile(imgData);
          // this.props.closeAddSignature(true);
        });
      }
    }
  };

  urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then((res) => res.arrayBuffer())
      .then(function (buf) {
        // var blobFile = new Blob([buf], {type: mimeType});
        // return blobFile;
        return new File([buf], filename, { type: mimeType });
      })
      .then((disputeAuthorizationForm) => {
        console.log(disputeAuthorizationForm);
        this.props.onDisputeAuthorizationFile(disputeAuthorizationForm);
        this.props.closeAddSignature(true);
      });
  };
  beginSignatureHandler = () => {
    this.setState({ signatureAdded: false });
  };
  endSignatureHandler = () => {
    this.setState({ signatureAdded: true });
  };
  beginGuardianSignatureHandler = () => {
    this.setState({ signatureAdded: false });
  };
  endGuardianSignatureHandler = () => {
    this.setState({ signatureAdded: true });
  };
  handleChange = (e) => {
    console.log("handlechange", e.target.id);
    console.log("handlechange", e.target.id.value);

    if (e.target.name === "address") {
      this.setState({
        address: e.target.value,
        errorAddress: "",
      });
      this.props.onConstructUpdatedAddress("streetAddress", e.target.value);
    }

    if (e.target.name === "street") {
      this.setState({
        street: e.target.value,
        errorStreet: "",
      });
      this.props.onConstructUpdatedAddress("street", e.target.value);
    }

    if (e.target.name === "city") {
      this.setState({
        city: e.target.value,
        errorCity: "",
      });
      this.props.onConstructUpdatedAddress("city", e.target.value);
    }

    if (e.target.name === "state") {
      this.setState({
        state: e.target.value,
        errorState: "",
      });
      this.props.onConstructUpdatedAddress("state", e.target.value);
    }

    if (e.target.name === "postalCode") {
      this.setState({
        zipCode: e.target.value,
        errorZipCode: "",
      });
      this.props.onConstructUpdatedAddress("postalCode", e.target.value);
    }
  };
  render() {
    const { t, i } = this.props;

    console.log(
      "this.props.newUploadData.isMinor",
      this.props.newUploadData.isMinor
    );
    // const elementInputStyle = {
    //   border: "0",
    //   borderBottom: "1px solid #777",
    //   padding: "0 8px",
    //   margin: "0 5px",
    //   marginBottom: "3px",
    //   minWidth: "240px",
    //   outline: "none",
    //   borderRadius: "0",
    //   width: "auto",
    //   minHeight: "auto",
    //   height: "auto",
    // };
    // const elementLabelStyle = {
    //   display: "none",
    // };
    const nextBtnStyle = {
      minWidth: "140px",
      marginRight: "10px",
    };
    // let trimmedUrl: any;
    // if (this.state.trimmedDataURL !== "") {
    //   trimmedUrl = <img src={this.state.trimmedDataURL} alt="form" />;
    // }
    let guardianSignPad: any;
    let majorSignPad: any;
    if (this.props.newUploadData.isMinor) {
      console.log("if", this.props.newUploadData.isMinor);
      guardianSignPad = (
        <SignaturePad
          canvasProps={{
            className: classes.signPad,
          }}
          ref={(ref) => {
            this.sigPadGuardian = ref;
          }}
          onBegin={this.beginGuardianSignatureHandler}
          onEnd={this.endGuardianSignatureHandler}
          clearOnResize={false}
        />
      );
      majorSignPad = <div className={classes.signPadDisable}></div>;
    } else {
      console.log("else", this.props.newUploadData.isMinor);
      guardianSignPad = <div className={classes.signPadDisable}></div>;
      majorSignPad = (
        <SignaturePad
          canvasProps={{ className: classes.signPad }}
          ref={(ref) => {
            this.sigPadPatient = ref;
          }}
          onBegin={this.beginSignatureHandler}
          onEnd={this.endSignatureHandler}
          clearOnResize={false}
        />
      );
    }
    return (
      <Fragment>
        <div className="popupHeader">
          <h6>{t("addSignature.signature")}</h6>
          <div
            className="closeBtn closeBtnBlue"
            onClick={() => this.props.closeAddSignature(false)}
          >
            X
          </div>
        </div>

        <div className={classes.bodyPopup}>
          <div
            className={classes.signContainer}
            style={{ minWidth: this.state.disputeFormWidth + "px" }}
            id="mainContainer"
          >
            <div className={classes.signContent}>
              <h6 className="text-center textSignSpace">
                <i>{t("addSignature.authorization")}</i>
              </h6>
              <div className={classes.textContent}>
                {t("addSignature.i")}{" "}
                {this.props.newUploadData.beneficiarySelected},{" "}
                {t("addSignature.dob")}{" "}
                {setDateFormat(this.props.newUploadData.dateOfBirth)},{" "}
                {t("addSignature.residingAt")}{" "}
                <div className="inline-input">
                  <small>*</small>
                  <Input
                    name="address"
                    placeholder={t("placeHolder.address1")}
                    value={this.state.address}
                    errorText={this.state.errorAddress}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                ,
                <div className="inline-input">
                  <small>*</small>
                  <Input
                    name="city"
                    placeholder={t("placeHolder.city")}
                    value={this.state.city}
                    errorText={this.state.errorCity}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                ,
                <div className="inline-input">
                  <small>*</small>
                  <Input
                    name="state"
                    placeholder={t("placeHolder.state")}
                    value={this.state.state}
                    errorText={this.state.errorState}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                ,
                <div className="inline-input">
                  <small>*</small>
                  <NumberFormat
                    format="#####"
                    placeholder={t("placeHolder.postalCode")}
                    name="postalCode"
                    value={this.state.zipCode}
                    // errorText={this.state.errorZipCode}
                    onChange={(e) => this.handleChange(e)}
                  />
                  <span className={classes.errorMsg}>
                    {this.state.errorZipCode}
                  </span>
                </div>
                {/* <span
                  className={[classes.inlineBox, classes.validate].join(" ")}
                >
                  <small>*</small>
                  <span
                    className={[
                      classes.customInputBox,
                      classes.customInputAddress,
                    ].join(" ")}
                    role="textbox"
                    contentEditable
                    onKeyUp={(e) => this.handleChange(e)}
                    id="address"
                  ></span>
                  <br />
                  <span className={classes.errorMsg}>
                    {this.state.errorAddress}
                  </span>
                   {/* <Input
                    elementInputStyle={elementInputStyle}
                    elementLabelStyle={elementLabelStyle}
                    //className={classes.customInputBox}
                    name="address"
                    value={this.state.address}
                    errorText={this.state.errorAddress}
                    onChange={(e) => this.handleChange(e)}
                  />{" "} 
                  <div className={classes.customInputBox}>
                  <TextareaAutosize />
                </div>  
                </span>*/}
                {/*
                <span
                  className={[classes.inlineBox, classes.validate].join(" ")}
                >
                  <small>*</small>
                  <span
                    className={[
                      classes.customInputBox,
                      classes.customInputStreet,
                    ].join(" ")}
                    role="textbox"
                    contentEditable
                    onKeyUp={(e) => this.handleChange(e)}
                    id="street"
                  ></span>
                  <br />
                  <span className={classes.errorMsg}>
                    {this.state.errorAddress}
                  </span>
                </span> */}
                {/* <span
                  className={[classes.inlineBox, classes.validate].join(" ")}
                >
                  <small>*</small>
                  <span
                    className={[
                      classes.customInputBox,
                      classes.customInputCity,
                    ].join(" ")}
                    role="textbox"
                    contentEditable
                    onKeyUp={(e) => this.handleChange(e)}
                    id="city"
                  ></span>
                  <br />
                  <span className={classes.errorMsg}>
                    {this.state.errorCity}
                  </span>
                </span> */}
                {/* <span
                  className={[classes.inlineBox, classes.validate].join(" ")}
                >
                  <small>*</small>
                  <span
                    className={[
                      classes.customInputBox,
                      classes.customInputState,
                    ].join(" ")}
                    role="textbox"
                    contentEditable
                    onKeyUp={(e) => this.handleChange(e)}
                    id="state"
                  ></span>
                  <br />
                  <span className={classes.errorMsg}>
                    {this.state.errorState}
                  </span>
                </span> */}
                {/* <span
                  className={[classes.inlineBox, classes.validate].join(" ")}
                >
                  <small>*</small>
                  <span
                    className={[
                      classes.customInputBox,
                      classes.customInputZip,
                    ].join(" ")}
                    role="textbox"
                    contentEditable
                    onKeyUp={(e) => this.handleChange(e)}
                    id="zipCode"
                  ></span>
                  <br />
                  <span className={classes.errorMsg}>
                    {this.state.errorZipCode}
                  </span>
                </span> */}
                , {t("addSignature.authorize")}
              </div>

              <ReactMarkdown>
                {t("addSignature.legalTerms", {
                  patient: {
                    fullName: this.props.newUploadData.beneficiarySelected,
                  },
                  clientGroup: {
                    name: localStorage.getItem("clientName"),
                  },
                })}
              </ReactMarkdown>

              <div className={classes.signBox}>
                <div className="row">
                  <div
                    className="col-md-6 col-sm-12"
                    style={{ width: this.state.signBox + "%" }}
                  >
                    <div className={classes.signTxtLabel}>
                      {t("addSignature.byPatient")}
                    </div>
                    {majorSignPad}
                  </div>

                  <div
                    className="col-md-6 col-sm-12"
                    style={{ width: this.state.signBox + "%" }}
                  >
                    <div className={classes.signTxtLabel}>
                      {t("addSignature.byGuardian")}
                    </div>
                    {guardianSignPad}
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-md-6 col-sm-12"
                    style={{ width: this.state.signBox + "%" }}
                  >
                    <div className={classes.signTxt}>
                      {t("addSignature.date")}
                      {this.state.currentDate}
                    </div>
                  </div>

                  <div
                    className="col-md-6 col-sm-12"
                    style={{ width: this.state.signBox + "%" }}
                  >
                    <div className={classes.signTxt}>
                      {t("addSignature.relationShip")}{" "}
                      {this.props.newUploadData.isMinor ? "Guardian" : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <h6>
                <i>{t("addSignature.copies")}</i>
              </h6>
            </div>
          </div>
        </div>

        <div className={classes.popupBottom}>
          <p>{t("addSignature.pleaseSign")}</p>
          <div className={classes.btnSigns}>
            <Button
              label={t("addSignature.reset")}
              clicked={this.clearSignature}
              style={nextBtnStyle}
              displayImg={false}
              image=""
              disabled={false}
            />
            <Button
              label={t("addSignature.apply")}
              clicked={() => this.captureFormInImage(false)}
              style={nextBtnStyle}
              displayImg={false}
              image=""
              disabled={!this.state.signatureAdded}
            />
            <Button
              label={t("addSignature.download")}
              clicked={() => this.captureFormInImage(true)}
              style={nextBtnStyle}
              displayImg={false}
              image=""
              disabled={this.state.signatureAdded ? false : true}
            />
            {/* {trimmedUrl} */}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  newUploadData: state.bbNewUpload.newUploadData,
});

const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onDisputeAuthorizationFile: (disputeAuthorizationForm) =>
    dispatch(actions.disputeAuthorizationFile(disputeAuthorizationForm)),
  onConstructUpdatedAddress: (name, value) =>
    dispatch(actions.constructUpdatedAddress(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSignature);
